import { EActionTypes } from '../../actions/page';
import { TReduxActions } from '../../types/redux';
import { IPage } from '../../types/redux/page';

export const initialState: IPage = {
  deviceType: 'desktop' as const,
  pageType: 'EstateCalculator',
  isWebview: false,
  stickyFooterVisible: false,
  stickyScrollBtnVisible: false,
  isValuationFiltersModalOpened: false,
  pushNotificationsAllowed: false,
  isPushSettingsModalOpened: false,
};

export function pageReducer(state: IPage = initialState, action: TReduxActions): IPage {
  switch (action.type) {
    case EActionTypes.SetValuationFiltersModalOpened:
      return {
        ...state,
        isValuationFiltersModalOpened: action.payload,
      };

    case EActionTypes.ToggleStickyFooterVisible:
      return {
        ...state,
        stickyFooterVisible: action.payload,
      };
    case EActionTypes.ToggleStickyScrollBtnVisible:
      return {
        ...state,
        stickyScrollBtnVisible: action.payload,
      };

    case EActionTypes.SetPushSettingsOpened:
      return {
        ...state,
        isPushSettingsModalOpened: action.payload,
      };

    case EActionTypes.SetPushNotificationsAllowed:
      return {
        ...state,
        pushNotificationsAllowed: action.payload,
      };

    default:
      return state;
  }
}
